import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import FeedUsageComponent from '@app/components/apps/FeedMaterialUsage/FeedMaterialUsage';

const AddFeedUsage = () => {
  const { setBreadcrumb, clearHeaderButtons } = useHeader();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Feed Usage');

  const routes = [
    { path: '/feed-material-usage', breadcrumbName: 'Feed Raw Material Usage' },
    { path: '/add-feed-usage', breadcrumbName: 'Add Feed Usage' },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <FeedUsageComponent
          editable={true}
          pageTitle={'Add Feed Usage'}
          type={'create'}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default AddFeedUsage;
